/**
 * Compares two strings (or null/undefined) using natural alphanumeric ordering,
 * so 'M9' sorts before 'M10' instead of after 'M1'.
 *
 * Null and undefined sort to the end of the list regardless of direction.
 */
export function naturalCompare(a: string | null | undefined, b: string | null | undefined): number {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}

/** Builds a comparator that applies naturalCompare to a getter result. */
export function naturalCompareBy<T>(getter: (item: T) => string | null | undefined): (a: T, b: T) => number {
  return (a, b) => naturalCompare(getter(a), getter(b));
}
